module.exports = __webpack_public_path__ + "static/scale-model-of-inner-space-cavern-in-round-rock-texas-96f370212f483605600324766b774838.png";